import { render, staticRenderFns } from "./GenomicBleed.vue?vue&type=template&id=f5679c2a&scoped=true"
import script from "./GenomicBleed.vue?vue&type=script&lang=js"
export * from "./GenomicBleed.vue?vue&type=script&lang=js"
import style0 from "./GenomicBleed.vue?vue&type=style&index=0&id=f5679c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5679c2a",
  null
  
)

export default component.exports